const PILLARS = [
  {
    title: "Guided learning",
    text: "Expert-led lectures and paid sessions built for O Level and A Level clarity.",
  },
  {
    title: "Curated resources",
    text: "Notes, worksheets, and materials organised so students can revise with confidence.",
  },
  {
    title: "Self-paced paths",
    text: "Flexible routes to explore subjects independently and master concepts step by step.",
  },
];

function MainAbout() {
  return (
    <section className="student-section student-about" aria-label="About">
      <div className="student-section__inner">
        <header className="student-section__header student-section__header--center student-about__header">
          <p className="student-section__eyebrow">Who we are</p>
          <h2 className="student-section__title">About Zainematics</h2>
          <p className="student-about__copy">
            We are dedicated to making high-quality learning accessible,
            structured, and engaging for O Level and A Level students. From
            comprehensive lectures and expert-led paid sessions to carefully
            curated free resources, our goal is to provide students with
            everything they need to learn with clarity and confidence. Beyond
            traditional lectures, our self-learning paths allow students to
            explore subjects at their own pace, build a strong conceptual
            foundation, and progressively master challenging topics through
            structured content and practice. Whether you are looking for guided
            instruction, additional resources to strengthen your understanding,
            or a flexible path for independent learning, our platform brings
            these experiences together in one place, helping students move
            beyond simply preparing for exams and towards genuinely
            understanding what they learn.
          </p>
        </header>

        <div className="student-about__pillars">
          {PILLARS.map((pillar) => (
            <article key={pillar.title} className="student-about__pillar">
              <h3 className="student-about__pillar-title">{pillar.title}</h3>
              <p className="student-about__pillar-text">{pillar.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default MainAbout;
